export default __webpack_public_path__ + "resources/icons/n200-868d.webp";